import axios from "axios";
import { AuthRycApiClient, RefreshTokenRequest, RefreshTokenResponse } from "./ApiServer";

export class SingletonRefreshClient {
    public static isRefreshing: boolean;
    public static isPartnerRefreshing: boolean;
    private constructor() {
    }
    public static setRefresh() {
        this.isRefreshing = true;
    }
    public static completeRefresh() {
        this.isRefreshing = false;
    }
    public static setPartnerRefresh() {
        this.isPartnerRefreshing = true;
    }
    public static completePartnerRefresh() {
        this.isPartnerRefreshing = false;
    }
    public static async refreshToken(): Promise<RefreshTokenResponse>{

        let tokens = await this.GetClientToAuth().refreshToken(new RefreshTokenRequest({
            accessToken: localStorage.getItem('token')!,
            refreshToken: localStorage.getItem('refresh_token')!
        }));
        if (tokens.accessToken === undefined) throw new Error('token is undefined');
        localStorage.setItem('token', tokens.accessToken);
        localStorage.setItem('token_expires', tokens.expireAt?.toString()!);
        localStorage.setItem('refresh_token', tokens.refreshToken!);
        return tokens;

    }
   
    private static GetClientToAuth(): AuthRycApiClient {
        const axiosApiInstance = axios.create();

        // Request interceptor for API calls
        axiosApiInstance.interceptors.request.use(
            async config => {
                if (config.headers === undefined) config.headers = {};
                // let culture = localStorage.getItem('i18nextLng');
                config.headers["TimeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // config.headers.set('accept-language', culture);
                config.headers.Accept = 'application/json';
                config.headers["Content-Type"] = 'application/json';

                return config;
            },
            error => {
                Promise.reject(error)
            });
        axiosApiInstance.interceptors.response.use((response) => {
            return response
        }, async function (error) {
            console.log('error', error);
            // const originalRequest = error.config;
            // if (error.response.status === 401) {
            //     console.log('401.1', window.location.href);
            //     var items = window.location.href.split("/");
            //     window.location.href = window.location.origin + '/' + items[1] + '/' + items[2];
            // }
            // if (error.response.status === 401 && !originalRequest._retry) {
            //     try {
            //         if (error.response.headers['is-token-expired'] === 'true') {
            //             console.log('refresh token', error);
            //             originalRequest._retry = true;
            //             await new APIUsersHelper().RefreshToken();
            //             axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('bearer');
            //             return axiosApiInstance(originalRequest);
            //         }
            //         else throw new Error('unathorized but refresh token not expires');
            //     }
            //     catch (e) {
            //         throw new Error('unable to refresh token');
            //     }
            // }
            return Promise.reject(error);
        });
        return new AuthRycApiClient(GetApiAddress(), axiosApiInstance);
    }
  
    // protected static 

}
export function GetApiAddress(): string {
    // console.log(process.env.REACT_APP_API_URL);
    // if (process.env.REACT_APP_API_URL === 'NOT')
    //     return '';
    // else return process.env.REACT_APP_API_URL!;
    return process.env.REACT_APP_API_URL!;
}